export default "__VITE_ASSET__5eae721a__"